import React from 'react';
import moment from 'moment';

import { Card } from 'react-bootstrap';
import { Chart, CommonSeriesSettings, Series, Export, ArgumentAxis, Margin, Legend, Tooltip, Grid, Label } from 'devextreme-react/chart';

import { getStatisticsFromOrigin } from "../helpers/requestHandler";
import { renderFullScreen } from '../helpers/utils';

const axisTitles = [
    { value: 'count', name: 'Communicated Notices' },
];

export const updateNoticesInstance = () => {
    window.lineChartHistoricNotices.loadData();
}

export const updateNoticesRange = () => {
  window.lineChartHistoricNotices.loadData();
}

class lineChartHistoricNotices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            instanceNames: [],
            dataSource: '',
            getData: ''
        };
        window.lineChartHistoricNotices = this;
    }

    async componentDidMount() {
        await this.loadData();  
    }

    updateData = () => {
        let results = [];
        this.state.getData.forEach((item) => {
            if(item.instance === global.config.dashboard.selectedInstance) {
                item.reportDate = moment(item.reportDate).format("DD/MM/YYYY")
                results.push(item);
            }
        })
        this.setState({ dataSource: results });
    }

    loadData = async () => {
        let resp = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetCommunicatedNoticesByInstanceRangeDaily", global.config.dashboard.range)
        let instanceNames = [];

        if(resp) {
          resp.forEach((item) => { 
            if(instanceNames.indexOf(item.instance) > -1) {} 
            else {
                instanceNames.push(item.instance)
            }
          });
          
          this.setState({getData: resp, instanceNames: instanceNames}, () => {
            this.updateData();
          });
        }
    }

  render() {
    if(this.state.getData !== null) {
        return (
        <Card className="rounded-4">
          <Card.Body>
            <Card.Title>
                Historic Notices ({global.config.dashboard.range} Days)
                <div className='float-end'>
                  <span className="fullscreen-link" onClick={() => {renderFullScreen("#lineChartNotices")}}>Full Screen</span>
                </div>
            </Card.Title>
            <Card.Subtitle>
              Number of Communicated Notices by Day for the selected instance
            </Card.Subtitle>
            <Chart
              id="lineChartNotices"
              palette="Violet"
              dataSource={this.state.dataSource}
              title={global.config.dashboard.selectedInstance}
            >
              <CommonSeriesSettings
                argumentField="reportDate"
                type="line"
              />
              {
                axisTitles.map((item) => <Series
                  key={item.value}
                  valueField={item.value}
                  name={item.name} />)
              }
              <Margin bottom={20} />
              <Tooltip
                enabled={true}
                location="edge"
                customizeTooltip={this.customizeTooltip}
                zIndex={10000}
              />
              <ArgumentAxis
                valueMarginsEnabled={false}
                discreteAxisDivisionMode="crossLabels"
              >
                <Label
                  wordWrap="break"
                  overlappingBehavior={"rotate"}
                />
                <Grid visible={true} />
              </ArgumentAxis>
              <Legend
                visible={false}
              />
              <Export enabled={true} />
            </Chart>
          </Card.Body>
          
        </Card>
      );
    }
  }

  customizeTooltip(arg) {
        return {
            text: `${arg.argumentText} \n ${arg.point.data.instance} - Communicated Notices: ${arg.valueText}`,
        }
    }
}

export default lineChartHistoricNotices;
